
import { useState, useEffect } from "react";
import { getApprovalFlowStrict } from "../services/approvalFlowService";
import { ApprovalFlow } from "../types/approval";

export function useApprovalFlow(module: string, targetId: string, explicitFlowId?: string | null) {
  const [flow, setFlow] = useState<ApprovalFlow | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If explicit ID is provided, verify it first
    const fetchId = explicitFlowId;

    if (!targetId && !fetchId) {
        setFlow(null);
        return;
    }

    setLoading(true);
    
    // Priority: Explicit ID -> Module+TargetId
    const params = fetchId ? { flowId: fetchId } : { module, targetId };

    getApprovalFlowStrict(params)
      .then(setFlow)
      .catch(err => {
         console.error("Approval Flow Fetch Error", err);
         setFlow(null);
      })
      .finally(() => setLoading(false));

  }, [module, targetId, explicitFlowId]);

  return { flow, loading };
}
